import {
  CircularProgress,
  FormControl,
  InputAdornment,
  Autocomplete as MuiAutocomplete,
  TextField
} from '@mui/material';
import FieldInfo from '../../field-info';
import Widget from '../widget';
import type { useAutocomplete } from './autocomplete-hook';

export type AutocompleteProps = ReturnType<typeof useAutocomplete>;

export function Autocomplete({
  value,
  error,
  isRequired,
  disabled,
  options,
  size,
  ListboxComponent,
  filterOptions,
  renderOption,
  getOptionLabel,
  startAdornment,
  handleChange,
  handleInputChange,
  isLoading,
  groupBy,
  multiple,
  isOptionEqualToValue,
  freeSolo,
  autoSelect,
  id,
  label,
  description,
  instructions,
  alert
}: AutocompleteProps) {
  return (
    <Widget testId={id} showHeader={false} showError={false} showDescription={false}>
      <FormControl variant="outlined" fullWidth error={Boolean(error)}>
        <MuiAutocomplete
          disablePortal
          options={options}
          ListboxComponent={ListboxComponent}
          filterOptions={filterOptions}
          renderOption={renderOption}
          getOptionLabel={getOptionLabel}
          multiple={multiple}
          value={value}
          disabled={disabled}
          loading={isLoading}
          freeSolo={freeSolo}
          autoSelect={autoSelect}
          onChange={handleChange}
          onInputChange={handleInputChange}
          groupBy={groupBy}
          isOptionEqualToValue={isOptionEqualToValue}
          renderInput={(params) => {
            return (
              <TextField
                {...params}
                size={size}
                label={label}
                required={isRequired}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: (
                    <>
                      {startAdornment && <InputAdornment position="start">{startAdornment}</InputAdornment>}
                      {params.InputProps.startAdornment}
                    </>
                  ),
                  endAdornment: (
                    <>
                      {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  )
                }}
              />
            );
          }}
        />
        <FieldInfo description={description} instructions={instructions} error={error} alert={alert} />
      </FormControl>
    </Widget>
  );
}
